import { useEffect } from 'react';
import { SubpageIntro2018, SubpageLayout2018 } from './subpageLayout';

const categories = [
  {
    title: 'Smart Mobility',
    icon: '/2018/images/mobility.png',
    content:
      'aims to enhance people’s mobility through infrastructure investments. They are summarised into the categories of pollution alleviation, traffic congestion easing, people safety enhancement, noise pollution reduction and transfer cost minimisation. Formulating a strategic roadmap for intelligent transport systems, providing multi-functionalities by sensors at public transport interchanges, developing an all-in-one transport mobile application, using Internet-of-Things (IoT) to improve the parking space search experience and upgrading the Hong Kong International Airport to a smart airport through automation - all these require smart vehicles, smart infrastructure, smart networks as well as smart control systems.',
  },
  {
    title: 'Smart Living',
    icon: '/2018/images/living.png',
    content:
      'focuses on improving an individual’s ability to interact with electronic services. It enables the general public’s confidence in using electronic services with ease of payments and authentication, at the same time promotes gerontechnology, which includes using wearable technology to track health and developing smart hospitals. It will help to offer preventative healthcare services and tailored medical advice to individuals. All these initiatives in combination will facilitate the improvement in, and the management of, the living environment and quality of life.',
  },
  {
    title: 'Smart Environment',
    icon: '/2018/images/environment.png',
    content:
      'changes how governments manage the built and natural environments. The aim is to optimise the use of city resources through "reduce, reuse and recycle", for example, promoting green and intelligent buildings, managing electrical grid with smart technology, increasing the efficiency of waste management, enhancing pollution management with remote sensors and improving energy efficiency in commercial settings. This will likely mean leveraging sensor technology, behavioural economics, and gamification to alter not only physical infrastructure, but to encourage positive resourcing decisions.',
  },
  {
    title: 'Smart People',
    icon: '/2018/images/people.png',
    content:
      'aims to transform the way people access public and private sector services and facilitates lifelong learning, in other words, to enhance Hong Kong’s capability in data science, providing convenient access to public services through a city "one-stop shop", using different Internet-based tools and the social media to gauge public views, and fostering entrepreneurial and innovative spirit through education. Simultaneously, Smart People looks to sustaining the momentum in driving and incentivising ICT adoption in the silver hair community while recognising ICT innovations that address challenges facing the aging society. People in Hong Kong are encouraged to participate in public affairs through online platforms and another application channels.',
  },
  {
    title: 'Smart Government',
    icon: '/2018/images/government.png',
    content:
      'serves its stakeholders through the deployment of supporting infrastructure that collates, analyses and presents city data in ways that encourage stakeholders’ participation. Smart Government also means that back-end processes, decision-making, information flow and implementation may all need a complete overhaul. Smart Government takes the initiative to prepare for the deployment of 5G mobile communication technology, instal multifunctional smart poles in the community, set up a virtual 3D simulated platform and offer more citizen-centric e-services. Further, it takes the lead to enhance the government’s data analytics capability, which is expected to result in the use of common utility tunnels and combination of electricity, water supply and sewer pipes in appropriate locations.',
  },
  {
    title: 'Smart Economy',
    icon: '/2018/images/economy.png',
    content:
      'strengthens the Hong Kong economy by improving the business climate. Smart Economy involves the improvement and promotion of the overall business climate, the advancement of Fintech and re-industrialisation, and city attractiveness for start-ups and investors. It will focus on facilitating re-industrialisation in Hong Kong, specifically, emerging technologies such as robotics, IoT, drones, 3D printing, AI and analytics, which can deliver high value-added manufacturing. Smart Tourism will contribute under the development of Smart Economy; it will leverage smart and innovative technologies to ease visitors’ interactions with the city, including navigation, finding services, trip planning - all this targets to enhance the overall tourist experience.',
  },
] as const;

const benefits = [
  'All Award Winners will be featured prominently on the Hong Kong Smart City Summit cum Smart City Awards 2018 minisite',
  'All Award Winners will get credible awards with reputable recognition and appreciation',
  'Use of the widely recognised branded winners logo on your website and marketing / publicity materials',
  'Media coverage reaching a cross platform audience',
  'Award winners report positive results including higher awareness, sales and levels of staff morale',
  'Awards supported by over 10 professional bodies and independently judged by a panel of over 10 experts',
  'Supported by major media partners and recognised quality branded sponsors',
] as const;

export default function Awards2018() {
  useEffect(() => {
    const acc = Array.from(document.getElementsByClassName('accordion')) as HTMLElement[];
    const handlers: Array<() => void> = [];
    acc.forEach((btn) => {
      const handler = () => {
        btn.classList.toggle('active');
        const panel = btn.nextElementSibling as HTMLElement | null;
        if (!panel) return;
        panel.style.maxHeight = panel.style.maxHeight ? '' : `${panel.scrollHeight}px`;
      };
      btn.addEventListener('click', handler);
      handlers.push(() => btn.removeEventListener('click', handler));
    });
    return () => handlers.forEach((off) => off());
  }, []);

  return (
    <SubpageLayout2018 lang="en" title="Award Categories" page="awards">
      <div className="award_categories">
        <SubpageIntro2018
          heading="Award Categories"
          intro="Hong Kong Smart City Awards 2018 comprises the six major categories under the blueprint of Smart City Hong Kong. Each category will have its own award title that distinguishes its contribution to its sector. The categories include:"
        />
        <div className="accordion_container">
          {categories.map((c, idx) => (
            <div key={c.title}>
              <button
                className="accordion animate"
                data-animate="flipInX"
                data-duration="1.0s"
                data-delay={`0.${idx + 1}s`}
                data-offset="100"
              >
                <div className="accordion_icons">
                  <img src={c.icon} alt="" />
                </div>
                {c.title}
              </button>
              <div className="panel">
                <p>
                  <span style={{ fontSize: 23 }}>{c.title}</span> {c.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="benefits">
        <div className="benefits_container">
          <div className="benefits_title">Benefits of the Award</div>
          <div className="animate benefits_text_container" data-animate="fadeIn" data-duration="1.5s" data-delay="0.1s" data-offset="100">
            {benefits.map((text, idx) => (
              <div key={text} className={`benefits_text b${idx + 1}`}>
                {text}
                <div className="corner">
                  <img src="/2018/images/corner.png" alt="" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

